module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/ashou0-815d2510d09f8b1500202c9a6a2c14be.jpg";